import React from 'react';

export const IconLink: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...props}>
        <path d="M6.5 9.5L9.5 6.5" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" />
        <path d="M7.5 4.5L8.6 3.4C9.7 2.3 11.5 2.3 12.6 3.4C13.7 4.5 13.7 6.3 12.6 7.4L11.5 8.5" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" />
        <path d="M8.5 11.5L7.4 12.6C6.3 13.7 4.5 13.7 3.4 12.6C2.3 11.5 2.3 9.7 3.4 8.6L4.5 7.5" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" />
    </svg>
);
